import React from 'react';
import {useTranslation} from 'react-i18next';
import cn from 'classnames';

import {ConnectionBad, ConnectionGood, ConnectionMedium} from 'components/common/icons/redesign/ConnectionTestIcons';

import useTooltip from 'hooks/common/useTooltip';

import {MINIMUM_DOWNLOAD_SPEED, MINIMUM_UPLOAD_SPEED} from 'helpers/testConnectionSettingsHelper';

import styles from './Participants.module.scss';

function Avatar({avatarURL, connectionTestResult, isSharing}) {
    return (
        <div className={cn(styles.avatarContainer, {[styles.sharing]: isSharing})}>
            <div className={styles.avatar} style={{backgroundImage: `url(${avatarURL})`}} />
            {connectionTestResult && <ConnectionStatus test={connectionTestResult} />}
        </div>
    );
}

const ConnectionStatus = ({test}) => {
    const {t} = useTranslation();
    const STATES = {
        goodConnection: 'goodConnection',
        badConnection: 'badConnection',
        browser: 'browser',
    };
    const icons = {
        [STATES.goodConnection]: props => <ConnectionGood {...props} className={styles.connectionIcon} />,
        [STATES.badConnection]: props => <ConnectionMedium {...props} className={styles.connectionIcon} />,
        [STATES.browser]: props => <ConnectionBad {...props} className={styles.connectionIcon} />,
    };

    let state = '';
    if (test.downloadSpeed > MINIMUM_DOWNLOAD_SPEED && test.uploadSpeed > MINIMUM_UPLOAD_SPEED)
        state = STATES.goodConnection;
    if (test.downloadSpeed <= MINIMUM_DOWNLOAD_SPEED || test.uploadSpeed <= MINIMUM_UPLOAD_SPEED)
        state = STATES.badConnection;
    if (test.browser && !['safari', 'chrome', 'ios', 'crios'].includes(test.browser.name)) state = STATES.browser;
    const {tooltip, hoverFunctions} = useTooltip(t(`waitingRoom:${state}`), styles.tooltip);

    return (
        <div>
            {icons[state](hoverFunctions)} {tooltip}
        </div>
    );
};

export default React.memo(Avatar);
